/**
 * Gets keep in touch frequency string value
 * @source Original location: UiUtils.ts.backup line 410
 */
export const keepInTouchFrequencyStringValue = (frequency: number, capitalize = false) => {
	if (frequency < 0) {
		return `${capitalize ? 'N' : 'n'}o ${capitalize ? 'S' : 's'}chedule`;
	}

	if (frequency === 12) {
		return `${capitalize ? 'Y' : 'y'}ear`;
	}

	return `${frequency > 1 ? frequency : ''} ${capitalize ? 'M' : 'm'}onth${frequency > 1 ? 's' : ''}`;
};

/**
 * Converts number to currency string value
 * @source Original location: UiUtils.ts.backup line 422
 */
export const numberToCurrencyStringValue = (value: number) => {
	return value.toLocaleString('en', {
		maximumFractionDigits: 2,
		minimumFractionDigits: 0,
	}); // e.g 0.00
};

/**
 * Converts number to USD currency string value
 * @source Original location: UiUtils.ts.backup line 429
 */
export const numberToUSDCurrencyStringValue = (value: number) => {
	return `${value.toLocaleString('en', {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
		style: 'currency',
		currency: 'USD',
	})}`; // e.g 0.00
};

/**
 * Converts number to formatted count
 * @source Original location: UiUtils.ts.backup line 438
 */
export const numberToFormattedCount = (value: number) => {
	return value.toLocaleString('en'); // e.g 1,000
};

/**
 * Sanitizes currency string value
 * @source Original location: UiUtils.ts.backup line 442
 */
export const sanitizeCurrencyStringValue = (inputString: string) => {
	const stringValueNumbers = (inputString || '').replace(/[^\d.-]/g, '');
	try {
		const asNumber = parseFloat(stringValueNumbers ? stringValueNumbers : '0');
		return asNumber.toFixed(2); // e.g 0.00
	} catch {
		return null;
	}
};
